import "./Home.module.css";
import KennelEliteHeader from "@/reusable_sections/Header";
import TheMileHighStandard from "./sections/TheMileHighStandard";
import NewArrivals from "./sections/NewArrivals";
import TheStaffyStandard from "./sections/TheStaffyStandard";
import HeritageExcellence from "./sections/HeritageExcellence";
import AboutCavaliers from "./sections/AboutCavaliers";
import HappyFamilies from "./sections/HappyFamilies";
import CallToAction from "./sections/CallToAction";
import AtlasRootsFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <KennelEliteHeader />
      <TheMileHighStandard />
      <NewArrivals />
      <TheStaffyStandard />
      <HeritageExcellence />
      <AboutCavaliers />
      <HappyFamilies />
      <CallToAction />
      <AtlasRootsFooter />
    </div>;
}